module.exports = __webpack_public_path__ + "static/img/login_logo_jj.948a1cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/config/login_logo_jj.png
// module id = 7oa+
// module chunks = 0